import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

export const initPartnersCarousel = () => {
  const el = document.querySelector('.partners__slider');
  if (!el) return;

  new Swiper(el, {
    modules: [Autoplay],
    slidesPerView: 2,
    spaceBetween: 24,
    loop: true,
    speed: 600,
    grabCursor: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      576: { slidesPerView: 3, spaceBetween: 32 },
      768: { slidesPerView: 4, spaceBetween: 40 },
      992: { slidesPerView: 5, spaceBetween: 48 },
      1200: { slidesPerView: 6, spaceBetween: 56 },
    },
  });
};
